exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-mobile__header__2MoeJ{color:#000;background:transparent}.header-mobile__title__2rMEn{margin:30px 0 25px;font-size:18px;font-weight:400;text-align:center}.header-mobile__close-button__1X650{position:absolute;top:-20px;right:0;width:auto;height:auto;font-size:14px;background:transparent;color:hsla(0,0%,100%,.6)}.header-mobile__close-button__1X650:hover{background:none}", ""]);

// exports
exports.locals = {
	"header": "header-mobile__header__2MoeJ",
	"title": "header-mobile__title__2rMEn",
	"close-button": "header-mobile__close-button__1X650",
	"closeButton": "header-mobile__close-button__1X650"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/shared/components/modal/header/header-mobile.styl
// module id = 1294
// module chunks = 0 1 2 3